module.exports = __webpack_public_path__ + "static/media/language.2c2c914b.png";